import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LangToggle } from "./LangToggle";
import { trackContactConversion } from "@/lib/gtag";

export const Footer = () => {
  const { t } = useTranslation();
  const COLUMNS = [
    {
      title: t("footer.platforms"),
      links: [
        { label: "AIP", to: "/platforms/aip" },
        { label: "Forge", to: "/platforms/forge" },
        { label: "Axis", to: "/platforms/axis" },
        { label: "Pulse", to: "/platforms/pulse" },
        { label: "Core", to: "/platforms/core" },
      ],
    },
    {
      title: t("footer.impact"),
      links: [
        { label: t("sectors.items.industry.name"), to: "/sectors/industry" },
        { label: t("sectors.items.healthcare.name"), to: "/sectors/healthcare" },
        { label: t("sectors.items.energy.name"), to: "/sectors/energy" },
        { label: t("sectors.items.public.name"), to: "/sectors/public" },
      ],
    },
    {
      title: t("footer.capabilities"),
      links: [
        { label: t("nav.platforms"), to: "/platforms" },
        { label: t("nav.sectors"), to: "/sectors" },
        { label: t("nav.model"), to: "/engagement" },
        { label: "How We Work", to: "/how-we-work" },
      ],
    },
    {
      title: t("footer.resources"),
      links: [
        { label: t("nav.about"), to: "/about" },
        { label: t("nav.impact"), to: "/impact" },
        { label: t("nav.contact"), to: "/contact" },
      ],
    },
  ];

  return (
    <footer id="footer" className="bg-background border-t border-border pt-20 pb-10">
      <div className="container-x">
        <div className="grid md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-4">
            <Link to="/" className="font-display text-2xl font-medium tracking-tight text-foreground">
              ARANON
            </Link>
            <p className="mt-2 text-xs uppercase tracking-[0.2em] text-muted-foreground">
              {t("footer.tagline")}
            </p>
            <p className="mt-6 text-sm text-muted-foreground max-w-xs leading-relaxed">
              {t("footer.blurb")}
            </p>
            <div className="mt-6">
              <LangToggle />
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="text-xs uppercase tracking-[0.2em] text-foreground mb-6">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      onClick={link.to === "/contact" ? trackContactConversion : undefined}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-border pt-8 flex flex-wrap items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © 2026 ARANON Technologies Inc. {t("footer.rights")}
          </p>
          <div className="flex items-center gap-6">
            {["LinkedIn", "X", "YouTube"].map((s) => (
              <a
                key={s}
                href="#"
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                {s}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
